export const environment = {
  production: true,
  apiUrl: 'https://app.unshadow.io/api/v1',
  redirectURI: 'https://app.unshadow.io',
  osintURI: 'https://app.unshadow.io',
};
